import React from 'react';

const PicturesPage: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-base-content mb-2">Картинки</h1>
        <p className="text-base-content/70">
          Управление картинками сделок
        </p>
      </div>
      
      <div className="max-w-md mx-auto">
        <div className="card bg-gradient-to-br from-secondary/5 to-secondary/10 border border-secondary/20">
          <div className="card-body text-center">
            <div className="w-16 h-16 mx-auto bg-secondary/20 rounded-full flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current text-secondary w-8 h-8">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"></path>
              </svg>
            </div>
            <h3 className="text-base font-semibold text-base-content mb-2">В разработке</h3>
            <p className="text-base-content/70 mb-4">
              Страница управления картинками находится в разработке. 
              Скоро здесь появится галерея и инструменты для работы с изображениями.
            </p>
            <div className="badge badge-secondary">Скоро</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PicturesPage;
